import Image from "next/image";

type ButtonItem = {
  icon: string;
  label: string;
  url: string;
  color: string;
};

type ButtonGroupSectionProps = {
  heading?: string;
  buttons: ButtonItem[];
  add_background?: boolean;
  add_bottom_border?: boolean;
};

export default function ButtonGroupSection({
  heading,
  buttons,
  add_background = false,
  add_bottom_border = false,
}: ButtonGroupSectionProps) {
  // Helper function to get the correct icon source
  const getIconSrc = (icon: string) => {
    // Handle null or undefined
    if (!icon) {
      return '/images/placeholder.png';
    }
    // If it's a full URL, use it directly
    if (icon.startsWith("http://") || icon.startsWith("https://")) {
      return icon;
    }
    // Otherwise, prepend /images/
    return `/images/${icon}`;
  };

  const content = (
    <>
      {heading && (
        <h2 className="text-3xl md:text-3xl font-bold text-primary-700 mt-12 mb-4">
          {heading}
        </h2>
      )}
      <div className={`flex gap-10 items-center flex-wrap ${add_bottom_border ? "pb-8 border-b border-gray-200" : ""}`}>
        {buttons.map((button, index) => (
          <div
            key={index}
            className="flex p-4 rounded-xl justify-center items-center"
            style={{ backgroundColor: button.color }}
          >
            <img
              src={getIconSrc(button.icon)}
              width={36}
              height={36}
              alt={button.label}
              className="w-18 h-18 rounded-xl"
            />
            <a
              href={button.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="text-white h-full pl-4 font-bold">
                {button.label}
              </span>
            </a>
          </div>
        ))}
      </div>
    </>
  );

  if (add_background) {
    return (
      <section
        className="
          w-screen relative left-1/2 right-1/2 -mx-[40vw]
          bg-[linear-gradient(to_bottom,rgba(237,237,249,0),#DEE5E8)]
          my-8 py-8
        "
      >
        <div className="bg-[url('/images/left-corner-supergrafis.png')] bg-no-repeat bg-left-bottom bg-[length:400px] py-8">
          <div className="container max-w-7xl mx-auto items-start gap-8 flex">
            <div className="flex-1 min-w-0 px-10">
              {content}
            </div>
            <div className="w-80 flex-shrink-0 lg:block"></div>
          </div>
        </div>
      </section>
    );
  }

  return <div className="w-full">{content}</div>;
}
